import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CoursesImage1 from "../Assets/courses/coursebgwhite.png";
import CoursesImage2 from "../Assets/courses/coursebgwhite.png";
import CoursesImage3 from "../Assets/courses/coursebgwhite.png";
import CoursesImage4 from "../Assets/courses/coursebgwhite.png";
import CoursesImage5 from "../Assets/courses/coursebgwhite.png";
import CoursesImage6 from "../Assets/courses/coursebgwhite.png";
import CoursesImage7 from "../Assets/courses/coursebgwhite.png";

import CourseCIVIL from "../Assets/courses/COURSECIVILss.png";
import Coursemech from "../Assets/courses/coursemech1.png";
import Courseaiml from "../Assets/courses/courseaiml.png";
import Courseeee from "../Assets/courses/courseee.png";
import Courseece from "../Assets/courses/courseece.png";
import Coursecse from "../Assets/courses/coursecse.png";
import Coursecloud from "../Assets/courses/coursecloud.png";

import { FaChevronCircleLeft } from "react-icons/fa";
import { FaChevronCircleRight } from "react-icons/fa";

import { BsFillArrowUpRightCircleFill } from "react-icons/bs";

const Courses = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [
    CoursesImage1,
    CoursesImage2,
    CoursesImage3,
    CoursesImage4,
    CoursesImage5,
    CoursesImage6,
    CoursesImage7,
  ];

  const content = [
    {
      id: 1,
      title: "ARTIFICIAL INTELLIGENCE & MACHINE LEARNING",
      description:
        "Artificial Intelligence and Machine Learning (AIML) is a new academic program introduced in 2021 at JPKP. This three-year diploma is headed by an eight-year experienced Head of Department and has a capacity of 60 students and each student will receive personalized mentoring from experienced faculty members. JPKP aims to provide AIML students with",
      buttonText: "Read More",
      img: Courseaiml,
      link: "/course-details/1",
      smscren: "AIML",
    },
    {
      id: 2,
      title: "COMPUTER ENGINEERING",
      description:
        "D.C.E or the Department of Computer Science and Engineering at JPKP college was introduced in 2013 and provides students with an advanced learning environment. The department has a capacity of 60 seats, headed by a 6 years-experienced Head of Department (HOD). It has 180 computer labs with experienced faculty members to provide",
      buttonText: "Read More",
      img: Coursecse,
      link: "/course-details/2",
      smscren: "CME",
    },
    {
      id: 3,
      title: "ELECTRONICS & COMMUNICATION ENGINEERING",
      description:
        "E.C.E (Electronics & Communication Engineering) is a diploma program introduced in 2013 at JPKP College, India. The program has 60 seats and is headed by an HOD with 13 years of experience in the field of Electronics and Communication Engineering.",
      buttonText: "Read More",
      img: Courseece,
      link: "/course-details/3",
      smscren: "ECE",
    },
    {
      id: 4,
      title: "CIVIL ENGINEERING",
      description:
        "The Department of Civil Engineering (D.C.E) at JPKP College was introduced in 2013 and has a capacity of 60 seats. It is headed by an experienced faculty with 7 years' experience and consists of all practical labs providing the students with hands-on experience. The college also employs experienced teachers who have worked in various industries to provide the students with",
      buttonText: "Read More",
      img: CourseCIVIL,
      link: "/course-details/4",
      smscren: "CIVIL",
    },
    {
      id: 5,
      title: "ELECTRICAL & ELECTRONICS ENGINEERING",
      description:
        "The Department of Electrical & Electronics Engineering (D.E.E.E) was introduced in JPKP College in 2013 to provide a platform for students to learn the fundamentals and advanced concepts of electrical engineering. ",
      buttonText: "Read More",
      img: Courseeee,
      link: "/course-details/5",
      smscren: "EEE",
    },
    {
      id: 6,
      title: "MECHANICAL ENGINEERING",
      description:
        "The Department of Mechanical Engineering (D.M.E) at JPKP college was introduced in 2013 with a capacity of 120 seats. It is headed by an experienced Head of Department, who has 7 years of experience in the field. The department focuses on providing students with a comprehensive education and practical training, with all the labs equipped with state-of-the-art technology and",
      buttonText: "Read More",
      img: Coursemech,
      link: "/course-details/6",
      smscren: "MECH",
    },
    {
      id: 7,
      title: "CLOUD COMPUTING AND BIG DATA",
      description:
        "The Department of Cloud Computing & Big Data (C.C.B.D.) at JPKP College, is set to be introduced in 2022. This department will have a total of 60 seats, and will be headed by an experienced faculty member with 8 years of experience in the field. All practical labs for this department will be equipped with the latest tools and technologies needed to study Cloud Computing & Big",
      buttonText: "Read More",
      img: Coursecloud,
      link: "/course-details/7",
      smscren: "CLOUD",
    },
  ];

  // Truncate text based on character length (50 characters)
  const truncateDescriptionByCharacters = (description, maxLength = 200) => {
    return description.length > maxLength
      ? description.slice(0, maxLength) + "..."
      : description;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length); // Loop through images
    }, 5000); // Change every 3 seconds
    return () => clearInterval(interval); // Clean up on component unmount
  }, [images.length]);

  // Determine the images to be displayed: one left, one center, one right
  const displayedImages = [
    images[(currentIndex - 1 + images.length) % images.length], // Left image
    images[currentIndex], // Center image
    images[(currentIndex + 1) % images.length], // Right image
  ];

  // Get corresponding content for left, center, and right images
  const displayedContent = [
    content[(currentIndex - 1 + content.length) % content.length], // Left content
    content[currentIndex], // Center content
    content[(currentIndex + 1) % content.length], // Right content
  ];

  return (
    <div className="bg-[#031220;]">
      <h1 className="text-center text-white font-bold text-4xl pt-7">
        Our Courses
      </h1>
      <hr
        className="section-divider my-1 border-t border-white mx-auto"
        style={{ width: "11%" }}
      />

      <div className="courses-container relative w-full h-[80vh] bg-[#031220] bg-cover bg-center flex justify-center overflow-hidden">
        <div className="carousel relative flex justify-center items-center overflow-hidden w-full">
          <div
            className="arrow-course text-[2rem] text-white bg-[rgba(247,245,245,0.5)] p-[10px] rounded-full cursor-pointer left-arrow relative left-[2%] top-[-1%] 
                sm:left-2 sm:top-[10%] md:top-[0%] lg:top-[10%] xl:top-[2%] 2xl:top-[-3%] md:left-0 lg:left-6 xl:left-[0.5%] 2xl:left-[0%]"
            onClick={() =>
              setCurrentIndex(
                (prevIndex) => (prevIndex - 1 + images.length) % images.length
              )
            }
          >
            <FaChevronCircleLeft size={28} />
          </div>

          <div
            className="carousel-track flex flex-col ml-[13%] sm:ml-[-1%] md:ml-[-1%] lg:ml-[-1%] xl:ml-[-1%] 2xl:ml-[-1%] sm:flex-row 
          w-[90%] sm:w-[90%] md:w-[80%] lg:w-[70%] xl:w-[90%] 2xl:w-[70%]"
          >
            {displayedImages.map((image, index) => (
              <div
                key={index}
                className={`carousel-item ${
                  index === 1 ? "center" : ""
                } w-[73%] rounded-[10px] mb-[15%] sm:mb-[15%] md:mb-[1%] lg:mb-[1%] xl:mb-[1%] 2xl:mb-[1%] relative sm:w-[80%] md:w-[50%] lg:w-[33%] xl:w-[60%] 2xl:w-[60%]`}
              >
                <img
                  src={image}
                  alt={`Course ${index + 1}`}
                  className="w-full object-cover"
                />
                <Link to={displayedContent[index].link}>
                  <div className="image-overlay absolute w-[85%] h-[90%] top-[20%] left-[50%] block rounded-[10px] p-[20px] text-center transform -translate-x-1/2 -translate-y-1/2">
                    <img
                      src={displayedContent[index].img}
                      alt="Course"
                      className="p-0 mt-[-12%] sm:p-5 md:p-5 lg:p-5 xl:p-5 2xl:p-5"
                    />
                    <h4
                      className="text-[16px]  font-semibold mb-3"
                      style={{ marginTop: "-8%" }}
                    >
                      <span className="sm:hidden ">
                        {displayedContent[index].title}
                      </span>
                      <span className="hidden sm:block">
                        {displayedContent[index].title}
                      </span>
                    </h4>
                    {/* <p className="description text-sm hidden sm:block md:text-sm lg:text-sm xl:text-sm 2xl:text-sm">
                      {truncateDescriptionByCharacters(displayedContent[index].description)}
                    </p> */}
                    <p className="description text-[12px] hidden xl:block 2xl:block">
                      {truncateDescriptionByCharacters(
                        displayedContent[index].description
                      )}
                    </p>
                  </div>
                </Link>
              </div>
            ))}
          </div>

          <div
            className="arrow-course text-[2rem] text-white bg-[rgba(247,245,245,0.5)] p-[10px] rounded-full cursor-pointer right-arrow relative right-[10px] top-[-1%] 
                sm:right-2  sm:top-[-1%] md:top-[0%] lg:top-[10%] xl:top-[3%] 2xl:top-[-3%] md:right-1 lg:right-6 xl:right-5 2xl:right-5"
            onClick={() =>
              setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length)
            }
          >
            <FaChevronCircleRight size={28} />
          </div>
        </div>

        <ol className="carousel-indicators absolute top-[90%] flex justify-center gap-2 mt-5 list-none p-0 bottom-5 w-full">
          {images.map((_, index) => (
            <li
              key={index}
              className={`w-[12px] h-[12px] bg-[rgba(255,255,255,0.5)] rounded-full cursor-pointer transition-all duration-300 ease-in-out 
          ${index === currentIndex ? "bg-white" : ""} 
          hover:bg-[rgba(255,255,255,0.8)]`}
              onClick={() => setCurrentIndex(index)}
            ></li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default Courses;
